module.exports = "<label>\n  <input class=\"checkbox\" type=\"checkbox\" name=\"checkbox-test\" (click)=\"onSelection()\" [checked]=\"selected\">\n  <span class=\"checkbox-custom\"></span>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/checkbox/checkbox.component.html
// module id = ./src/app/shared/checkbox/checkbox.component.html
// module chunks = main